import { Component } from '@angular/core'


@Component({
  selector: 'se-po-profile-bar-docs',
  templateUrl: './profile-bar-docs.component.html',
  styleUrls: ['./profile-bar-docs.component.scss'],
  standalone: false,
})
export class ProfileBarDocsComponent {
  public headers: string[] = [
    'Property',
    'Type',
    'Description',
  ]
  public profileBarComponent: any = [
    {
      Property: '@Input() selfPersona',
      Type: 'Persona',
      Description: 'Current user\'s persona',
    }
  ]
}
